export const RAILCARDS_CODES = {
  SAVER_1617: 'TSU',
  JPR: 'JPR',
}

export const BRAND_CODES = {
  SE: 'SE',
  TL: 'TL',
  SN: 'SN',
  GN: 'GN',
  GX: 'GX',
  TH: 'TH',
  TB: 'TB',
  TP: 'TP',
};

export const TICKET_TYPES = {
  SEASON: 'season',
  POINT: 'point',
  SMART_CARNET: 'smart-carnet',
};
